import { Env } from '@/shared/config/environment';
import { HttpClient } from '@/shared/lib/http-client';

export const takeAccidentContract = async (contractId) => {
  const response = await HttpClient.post(`${Env.server.mode}/insurance/accident/contract/take`, {
    contractId,
  });

  return response.data;
};
